export const nextStepTimeout = (fn: () => void, ms: number = 300) => {
  setTimeout(() => {
    fn();
  }, ms);
};
